import React from "react";
import GlobalMetaTags from "../components/globalMetaTags";
import BottomMenu from "../components/MenuBottom";

import setBodyColor from "../js/setBodyColor";

import LoaderFake from "../components/LoaderFake";

import Loader from "../components/loader";
import ConnectInfo from "../components/ConnectInfo";

const Connect = (props) => {
  setBodyColor({ color: "#ffffff" });

  return (
    <main>
      <GlobalMetaTags pageTitle={"Connect"} />
      <LoaderFake />
      <BottomMenu />

      <div id="connect">
        <ConnectInfo label="for all inquiries" email="projects@ximonlee.com" />

        {/*         <div style={{ color: "white" }}>·</div>
         */}
        {/*  <ConnectInfo
          label="sales and online store"
          email="sales@ximonlee.com"
        /> */}
        {/*  <ConnectInfo label="sales China" email="menswear@xcommons.com" /> */}
      </div>

      <div id="credit" className="circle">
        <a
          href="https://ff87c3.eu/"
          /*  style={{ textDecoration: "none" }} */
          target="_blank"
        >
          <p>
            site by
            <br />
            ff87c3.eu
          </p>
        </a>
      </div>
    </main>
  );
};

export default Connect;
